module.exports = __webpack_public_path__ + "img/btn_menu-open.8cf0909a.png";